<template>
  <div>
    <el-row type="flex" justify="flex-end">
      <el-col :span="6">
        <el-row type="flex">
          <el-col>
            <el-tooltip content="Terminales activas">
              <el-tag type="success">{{ this.cantidadact }}</el-tag>
            </el-tooltip>
          </el-col>

          <el-col>
            <el-tooltip content="Terminales Activos">
              <el-tag type="danger">{{ this.cantidadina }}</el-tag>
            </el-tooltip>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <rabbey-table3
          ref="table"
          :loading="loading"
          :data="datosFormateados"
          :columns="columns"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import { mapMutations, mapActions, mapGetters } from "vuex";
// import ReportGpsDetailHistory from "@/components/reports/ReportsGpsDetailHistory.vue";
// import { getPaginatedItems } from "@/utils";
import RenderCheckLabel from "@/components/functionals/RenderCheckLabel";

export default {
  name: "TableGpsStatus",
  prop: ["clientCode"],

  data() {
    return {
      scode: "",
      sid: 0,
      cantidadina: 0,
      cantidadact: 0,
      loading: false,
      items: [],
      itemsOriginal: [],
      datosFormateados: [],
      columns: [
        {
          prop: "terminalid",
          label: "Terminal ID",
          minWidth: 50
        },
        {
          prop: "nombre",
          label: "Nombre",
          minWidth: 80
        },
        {
          prop: "status",
          label: "Estatus",
          minWidth: 30,
          formatter: RenderCheckLabel
        },
        {
          prop: "telefono",
          label: "Telefono",
          minWidth: 100
        }
      ],

      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      totalGPS: 0,
      totalGpsClones: 0
    };
  },

  methods: {
    async getItems2(client_code) {
      this.scode = client_code;
      this.loading = true;
      this.loading = true;
      this.$http
        .get("/api/tennos/GetTerminales", {
          params: {
            rnc: client_code
          }
        })
        .then((response) => {
          this.items = response.data;
          this.cantidadina = this.items.filter(
            (c) => c.status === "INA"
          ).length;
          this.cantidadact = this.items.filter(
            (c) => c.status === "ACT"
          ).length;

          this.datosFormateados = response.data.map((item) => {
            if (item.status === "ACT") {
              return {
                ...item,
                status: true
              };
            } else {
              return {
                ...item,
                status: false
              };
            }
          });
        })
        .catch((error) => console.error(error))
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
